module.exports = __webpack_public_path__ + "img/zayn.25522548.jpg";